import {
    ClipboardCheck,
    Download,
    Images,
    Pencil,
    Settings,
    Workflow,
    Target,
    type LucideIcon,
} from 'lucide-react';
import type { IconType } from 'react-icons';
import { RiImageAiLine } from 'react-icons/ri';
import type { WorkflowStageId } from '~/domain/workflow/workflowStages';

/** Glyph of each workflow stage, as the viewer's step rail shows it. */
export const WORKFLOW_STAGE_ICONS: Record<
    WorkflowStageId,
    LucideIcon | IconType
> = {
    setup: Settings,
    syntheticImaging: RiImageAiLine,
    imageRegistration: Images,
    contouring: Pencil,
    review: ClipboardCheck,
    dosePlanning: Target,
    adapt: Workflow,
    export: Download,
};
